<template>
  <div v-if="transaction">
    <crypto-details :dataTransaction.sync="transaction" @userUpdated="updateUser" />
    <user-details class="mt-4" :dataUser="transactionUser">
      <h1 slot="header">User Information</h1>
    </user-details>
    <update-reason :data.sync="transaction.history" class="mt-4" />
  </div>
</template>

<script>
import UserDetails from "@/app/users/detail";
import CryptoDetails from "./details";
import UpdateReason from "@/app/updateReason/show";

export default {
  components: { UserDetails, CryptoDetails, UpdateReason },
  props: {
    id: {
      required: true,
      type: String,
    },
  },
  data: () => ({
    transaction: null,
    transactionUser: null,
  }),
  created() {
    this.$http.get(`api/v1/cryptoTransactions/${this.id}`).then((transaction) => {
      this.transaction = transaction;
      this.transactionUser = transaction.user;
    });
  },
  methods: {
    updateUser(user) {
      this.transactionUser = user;
    },
  },
};
</script>
